import { render } from "./Category.vue?vue&type=template&id=54b7c19f"
import script from "./Category.vue?vue&type=script&lang=js"
export * from "./Category.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/s.thebuyhive.com/expertsourcing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__